import { Link } from 'react-router-dom';
import { Container, Typography } from '@mui/material';
import { useAsyncValue } from 'framework/utils';

interface Page404Props {
  isAuthenticated: () => Promise<boolean>;
}

const Page404 = ({ isAuthenticated }: Page404Props) => {
  const isUserAuthenticated = useAsyncValue(isAuthenticated);

  return (
    <Container
      sx={{
        justifyContent: 'center',
        minHeight: 'calc(100vh - 90px)',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Typography variant="display0" component="h1" mr={3.75} sx={{ float: 'left' }} color="primary">
        404
      </Typography>
      <div>
        <Typography variant="h4" mb={1} pt={1.5}>
          Page not found.
        </Typography>
        {isUserAuthenticated && (
          <Typography color="textSecondary">
            You can go back to&nbsp;
            <Link to="/">One Stop</Link>
          </Typography>
        )}
      </div>
    </Container>
  );
};

export default Page404;
